import Vue from 'vue'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
    {
        //默認地址
        path: '/',
        component: () => import('@/views/index/index.vue'),
        children: [{
            path: "/",
            name: 'home',
            component: () => import('@/views/index/home/home.vue'),
        },
        {
            path: '/stadium',
            name: 'stadium',
            component: () => import('@/views/index/stadium/stadium.vue'),
        },
        {
            path: "/my",
            name: 'my',
            component: () => import('@/views/index/my/my.vue'),
        },
        {
            path: '/wallet',
            name: 'wallet',
            component: () => import('@/views/index/wallet/wallet.vue')
        }]
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/login.vue'),
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('@/views/register/register.vue'),
    },

    {
        path: '/forgotpwd',
        name: 'forgotpwd',
        component: () => import('@/views/forgotpwd/forgotpwd.vue'),
    },
    {
        path: '/stadium/:id',
        name: 'stadium-detail',
        component: () => import('@/views/stadium-detail/stadium-detail.vue')
    },
    //轉票確認
    {
        //path: '/wallet/transfer/:id',
        path: '/service/transfer/confirm/:id',
        name: 'wallet-transfer-confirm',
        component: () => import('@/views/wallet-detail/transfer-confirm.vue')
    },
    //票夾詳情
    {
        path: '/wallet/:id',
        name: 'wallet-detail',
        component: () => import('@/views/wallet-detail/wallet-detail.vue')
    },
    {
        path: '/map',
        name: 'map',
        component: () => import('@/views/map/map.vue')
    }
    ,
    {
        /* 課程列表 */
        path: '/course',
        name: 'course',
        component: () => import('@/views/service-list/course/course.vue')
    },
    {
        /* 活動列表 */
        path: '/activity',
        name: 'activity',
        component: () => import('@/views/service-list/activity/activity.vue')
    },
    {
        /* 比賽列表 */
        path: '/competition',
        name: 'competition',
        component: () => import('@/views/service-list/competition/competition.vue')
    },
    {
        /* 臨打列表 */
        path: '/linda',
        name: 'linda',
        component: () => import('@/views/service-list/linda/linda.vue')
    },

    {
        /* 服務詳情 */
        path: '/service/:id',
        name: 'service-detail',
        component: () => import('@/views/service-detail/service-detail.vue')
    },
    {
        path: '/edituser',
        name: 'edituser',
        component: () => import('@/views/edituser/edituser.vue')
    },
    {
        path: '/recharge',
        name: 'recharge',
        component: () => import('@/views/recharge/recharge.vue')
    },
    {
        path: '/points',
        name: 'points',
        component: () => import('@/views/points/points.vue')
    },
    {
        path: '/points/transfer/:code',
        name: 'points-transfer',
        component: () => import('@/views/points/points-transfer.vue')
    },
    {
        path: '/points/transfer/confirm/:code',
        name: 'points-transfer-confirm',
        component: () => import('@/views/points/points-transfer-confirm.vue')
    },
    {
        path: '/payment/:id',
        name: 'payment',
        component: () => import('@/views/stored/payment.vue')
    },
    {
        path: '/success/:id',
        name: 'success',
        component: () => import('@/views/stored/success.vue')
    },
    {
        path: '/confirm/:id',
        name: 'confirm',
        component: () => import('@/views/stored/confirm.vue')
    },
    {
        path: '/service/confirm/:id',
        name: 'service-confirm',
        component: () => import('@/views/stored/service-confirm.vue')
    },
    // {
    //     path: '/competition/confirm/:id',
    //     name: 'competition-confirm',
    //     component: () => import('@/views/stored/competition-confirm.vue')
    // },
    {
        path: '/invoice',
        name: 'invoice',
        component: () => import('@/views/invoice/invoice.vue')
    },
    {
        path: '/invoice/insert',
        name: 'invoice-insert',
        component: () => import('@/views/invoice/invoice-insert.vue')
    },
    {
        path: '/invoice/edit/:id',
        name: 'invoice-edit',
        component: () => import('@/views/invoice/invoice-edit.vue')
    },
    {
        path: '/invoice/success',
        name: 'invoice-success',
        component: () => import('@/views/invoice/invoice-success.vue')
    },
    {
        path: '/invoice/confirm/:id',
        name: 'invoice-confirm',
        component: () => import('@/views/invoice/invoice-confirm.vue')
    },
    {
        path: '/mycollection',
        name: 'mycollection',
        component: () => import('@/views/mycollection/mycollection.vue')
    },
    {
        //品牌回饋活動
        path: '/feedback',
        name: 'feedback',
        component: () => import('@/views/feedback/feedback.vue')
    },
    {
        //品牌回饋活動
        path: "/feedback/:id",
        name: 'feedback-details',
        component: () => import('@/views/feedback/feedback-details.vue')
    },
    {
        //通知
        path: "/notice",
        name: 'notice',
        component: () => import('@/views/notice/notice.vue')
    },
    {
        path: "/line/callback",
        name: 'line-callback',
        component: () => import('@/views/security/line/callback.vue'),
    },

];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
})


router.beforeEach((to, from, next) => {
    document.title = to.meta.title || 'PaiSport';
    next();
});

export default router